<template>
  <div class="bodycontent">
    <div class="page_title">
      功能开关
    </div>
    <div class="page_form">
      <el-form
        :model="formData"
        size="small"
        label-width="120px"
        v-loading="loading1"
      >
        <!-- <div class="part_name">首页设置</div> -->
        <el-form-item label="首页设置">
          <div class="menu_item" v-for="item in menuOptions" :key="item.id">
            <span class="menu_item_name">{{ item.name }}</span>
            <el-switch v-model="item.value" active-color="#13ce66"></el-switch>
          </div>
        </el-form-item>
        <el-form-item label="打印设置">
          <!-- <div>样式选择</div>
          <div class="img_list">
            <div class="img_item" v-for="(item,index) in imgList" :key="index" :class="{img_selected: item.value}" @click="selectImg(index)">
              <img :src="item.imgUrl" alt="">
              <div class="img_text">{{item.text}}</div>
            </div>
          </div> -->
          <div>
            <div class="menu_item">
              <span class="menu_item_item">订单是否打印</span>
              <el-switch
                v-model="order_print_status"
                active-color="#13ce66"
              ></el-switch>
            </div>
            <div class="menu_item">
              <span class="menu_item_item">充值是否打印</span>
              <el-switch
                v-model="recharge_print_status"
                active-color="#13ce66"
              ></el-switch>
            </div>
            <div class="menu_item">
              <span class="menu_item_item">普通订单是否打印</span>
              <el-switch
                v-model="normal_print_status"
                active-color="#13ce66"
              ></el-switch>
            </div>
            <div class="menu_item">
              <span class="menu_item_item">便利店是否打印</span>
              <el-switch
                v-model="credit_print_status"
                active-color="#13ce66"
              ></el-switch>
            </div>
            <div class="menu_item">
              <span class="menu_item_item">隐藏手机号</span>
              <el-switch
                v-model="print_hide_mobile"
                active-color="#13ce66"
              ></el-switch>
            </div>
            <div>
              <span class="menu_item_name" style="margin-left:10px"
                >备注提醒</span
              >
              <el-switch
                v-model="print_remark"
                active-color="#13ce66"
                style="margin-right: 10px"
              ></el-switch>
              <el-input
                v-if="print_remark"
                style="width: auto;"
                size="small"
                v-model="print_remark_value"
                placeholder="提醒文本"
              ></el-input>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="买单页面">
          <!-- <div>样式选择</div>
          <div class="img_list">
            <div class="img_item" v-for="(item,index) in imgList" :key="index" :class="{img_selected: item.value}" @click="selectImg(index)">
              <img :src="item.imgUrl" alt="">
              <div class="img_text">{{item.text}}</div>
            </div>
          </div> -->
          <div>
            <span class="menu_item_name" v-if="receipt_button"
              >开票是否扣除当次订单积分</span
            >
            <el-switch
              v-model="receipt_point"
              v-if="receipt_button"
              active-color="#13ce66"
            ></el-switch>
            <span
              class="menu_item_name"
              :style="{
                marginLeft: receipt_button ? '50px' : ''
              }"
              >是否隐藏充值</span
            >
            <el-switch
              v-model="hide_recharge_button"
              active-color="#13ce66"
            ></el-switch>
            <!-- <span class="menu_item_name" style="margin-left:50px"
              >是否显示油枪</span
            >
            <el-switch v-model="show_cate" active-color="#13ce66"></el-switch> -->
            <span class="menu_item_name" style="margin-left:50px"
              >自定义买单金额</span
            >
            <el-switch
              v-model="custom_money"
              active-color="#13ce66"
            ></el-switch>
            <span v-if="custom_money">
              <span class="menu_item_name" style="margin-left: 10px;"
                >金额</span
              >
              <el-input
                v-for="(item, index) in arrs"
                :key="index"
                style="width: 100px;margin-right: 10px;"
                v-model="arrs[index]"
                placeholder="金额"
              ></el-input>
              <!-- <span style="font-size:12px;color: red;"> 最多只能添加三个!!</span> -->
            </span>
            <span>
              <span class="menu_item_name" style="margin-left: 10px;"
                >默认使用积分</span
              >
              <el-switch
                v-model="default_use_point"
                active-color="#13ce66"
              ></el-switch>
            </span>
            <span class="menu_item_name" style="margin-left:10px"
              >是否隐藏升数</span
            >
            <el-switch v-model="hide_unit" active-color="#13ce66"></el-switch>
            <span class="menu_item_name" style="margin-left:10px"
              >充值提醒</span
            >
            <el-switch
              v-model="recharge_notice"
              active-color="#13ce66"
              style="margin-right: 10px"
            ></el-switch>
            <el-input
              v-if="recharge_notice"
              style="width: auto;"
              size="small"
              v-model="recharge_notice_value"
              placeholder="提醒文本"
            ></el-input>
          </div>
        </el-form-item>
        <el-form-item label="POS设置">
          <div class="menu_item" v-for="item in basicsOptions" :key="item.id">
            <span class="menu_item_name">{{ item.name }}</span>
            <el-switch v-model="item.value" active-color="#13ce66"></el-switch>
          </div>
        </el-form-item>
        <el-form-item label="支付限制">
          <div>
            <span class="menu_item_name">现金支付是否自动凑整</span>
            <el-switch v-model="cash_int" active-color="#13ce66"></el-switch>
            <el-popover
              placement="top-start"
              title="现金凑整"
              width="200"
              trigger="hover"
              content="对现金收款的订单金额四舍五入，给现金收款带来便利，避免找零"
            >
              <el-button slot="reference" type="text" class="ques_button">
                <i class="el-icon-question"></i>
              </el-button>
            </el-popover>
          </div>
          <div>
            <span
              class="menu_item_name"
              style="margin-right:30px;margin-top:10px"
              >油品消费限制</span
            >
            <span>
              <el-checkbox v-model="gas_oil">
                汽油
                <el-input
                  class="input_box_mini"
                  size="mini"
                  v-model="gas_oil_value"
                  @focus="gas_oil = true"
                  @change="gasChange"
                ></el-input>
                元
              </el-checkbox>
              <el-checkbox v-model="diesel_oil">
                柴油
                <el-input
                  class="input_box_mini"
                  size="mini"
                  v-model="diesel_oil_value"
                  @focus="diesel_oil = true"
                  @change="dieselChange"
                ></el-input>
                元
              </el-checkbox>
            </span>
          </div>
          <div>
            <span
              class="menu_item_name"
              style="margin-right:10px;margin-top:10px"
              >限制消费次数</span
            >
            <el-switch
              v-model="limit_custom"
              active-color="#13ce66"
            ></el-switch>
            <span v-if="limit_custom">
              <el-input
                style="margin-left: 10px"
                class="input_box_mini"
                size="mini"
                @blur="limit_custom_blur"
                v-model="limit_custom_value"
              ></el-input>
              次
            </span>
          </div>
        </el-form-item>
        <el-form-item label="用户设置" v-if="app_id == 389 || app_id == 413">
          <div>
            <div class="menu_item">
              <span class="menu_item_item">是否强制注册</span>
              <el-switch
                v-model="must_register"
                active-color="#13ce66"
              ></el-switch>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="退款设置">
          <div>
            <div class="menu_item">
              <span class="menu_item_item">订单退优惠券</span>
              <el-switch
                style="margin-left: 10px;"
                v-model="refund_order_take_coupon"
                active-color="#13ce66"
              ></el-switch>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="开票设置">
          <div>
            <div class="menu_item">
              <span class="menu_item_item">订单开票按钮</span>
              <el-switch
                style="margin-left: 10px;"
                v-model="invoice_button"
                active-color="#13ce66"
              ></el-switch>
              <el-date-picker
                v-if="invoice_button"
                v-model="invoice_create_time"
                type="date"
                style="margin-left: 20px;"
                placeholder="选择日期"
              >
              </el-date-picker>
            </div>
            <div class="menu_item">
              <span class="menu_item_item">是否显示专用发票</span>
              <el-switch
                style="margin-left: 10px;"
                v-model="receipt_button"
                active-color="#13ce66"
              ></el-switch>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="安全设置">
          <div>
            <div class="menu_item">
              <span class="menu_item_item">设置密码验证码</span>
              <el-switch
                style="margin-left: 10px;"
                v-model="open_client_user_paypass"
                active-color="#13ce66"
                @change="onClientPaypassChange"
              ></el-switch>
            </div>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="save_button">
      <el-button size="small" type="primary" @click="save()">保存</el-button>
    </div>
  </div>
</template>
<script>
import {
  getConfigButton,
  getConfigButtonPos,
  setConfigButton,
  setConfigButtonPos
} from "@/api/set";
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      formData: {},
      menuOptions: [
        { id: "buy_bill", name: "买单功能", value: true },
        { id: "coupon_center", name: "领券中心", value: true },
        { id: "room_nav", name: "油站导航", value: true },
        { id: "recharge", name: "充值有礼", value: true },
        { id: "team_card", name: "车队卡", value: true },
        { id: "family_card", name: "亲属卡", value: true },
        // { id: "invitation", name: "邀请赚钱", value: true },
        { id: "big_wheel", name: "大转盘", value: true },
        { id: "sign", name: "签到功能", value: true },
        { id: "price_show", name: "油价显示", value: true },
        { id: "wash_car", name: "洗车显示", value: true }
      ],

      basicsOptions: [
        { id: "oil_gun", name: "是否需要油枪选择", value: true },
        { id: "member_discount", name: "是否享受会员折扣", value: true },
        { id: "employee", name: "是否需要选择员工", value: true },
        { id: "point_discount", name: "是否享受积分抵扣", value: true },
        { id: "coupon_discount", name: "是否可用优惠券", value: true },
        { id: "receipt_button", name: "是否显示开票按钮", value: true },
        { id: "receipt_point", name: "开票是否扣除积分", value: true },
        { id: "recharge_print_status", name: "充值自动打印", value: false },
        { id: "order_print_status", name: "买单自动打印", value: false },
        { id: "normal_print_status", name: "普通订单自动打印", value: false },
        { id: "credit_print_status", name: "便利店自动打印", value: false },
        { id: "recharge_cash", name: "充值开启现金支付", value: false },
        {
          id: "hide_recharge_custom",
          name: "是否隐藏自定义充值",
          value: false
        }
      ],
      invoice_create_time: "",
      limit_custom: false,
      limit_custom_value: "",
      receipt_button: false,
      receipt_point: true,
      custom_money: false,
      default_use_point: true,
      hide_unit: false,
      recharge_notice: false,
      recharge_notice_value: "",
      print_remark: false,
      print_remark_value: "",
      // custom_money_value:'',
      custom_money_value1: "",
      custom_money_value2: "",
      custom_money_value3: "",
      hide_recharge_button: false,
      cash_int: true,
      show_cate: true,
      gas_oil: false,
      gas_oil_value: "",
      diesel_oil: false,
      diesel_oil_value: "",
      arrs: ["100", "200", "300"],
      imgList: [
        { imgUrl: "", text: "油枪字号大", value: true },
        { imgUrl: "", text: "油枪字号小", value: false },
        { imgUrl: "", text: "油品字号大", value: true },
        { imgUrl: "", text: "油品字号小", value: false }
      ],
      loading1: false,
      order_print_status: false,
      must_register: false,
      recharge_print_status: false,
      normal_print_status: false,
      credit_print_status: false,
      print_hide_mobile: true,
      refund_order_take_coupon: false,
      invoice_button: false,
      open_client_user_paypass: true
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    onClientPaypassChange(val) {
      if (!val) {
        this.$confirm("关闭会造成账户风险，自行承担", "提示", {
          type: "warning",
          center: true
        })
          .then(() => {
            this.save();
          })
          .catch(() => {
            this.open_client_user_paypass = true;
          });
      }
    },
    // blur(){
    //   if(this.custom_money_value1!==''){
    //     this.arrs.push(this.custom_money_value1)
    //   }
    //   if(this.custom_money_value2!==''){
    //     this.arrs.push(this.custom_money_value2)
    //   }
    //   if(this.custom_money_value3!==''){
    //     this.arrs.push(this.custom_money_value3)
    //   }
    // },
    limit_custom_blur() {
      if (
        this.limit_custom_value.includes("-") ||
        this.limit_custom_value.includes(".")
      ) {
        this.limit_custom_value = "";
      }
    },
    init() {
      this.loading1 = true;
      var data = {
        token: this.token,
        app_id: this.app_id
      };
      getConfigButton(data).then(res => {
        this.loading1 = false;
        if (res.code == 200) {
          console.log(res.data);
          res.data.value.forEach(item => {
            if (item.name == "receipt_button") {
              this.receipt_button = item.status == 1 ? true : false;
            } else if (item.name == "receipt_point") {
              this.receipt_point = item.status == 1 ? true : false;
            } else if (item.name == "cash_int") {
              this.cash_int = item.status == 1 ? true : false;
            } else if (item.name == "show_cate") {
              this.show_cate = item.status == 1 ? true : false;
            } else if (item.name == "order_print_status") {
              this.order_print_status = item.status == 1 ? true : false;
            } else if (item.name == "recharge_print_status") {
              this.recharge_print_status = item.status == 1 ? true : false;
            } else if (item.name == "normal_print_status") {
              this.normal_print_status = item.status == 1 ? true : false;
            } else if (item.name == "credit_print_status") {
              this.credit_print_status = item.status == 1 ? true : false;
            } else if (item.name == "print_hide_mobile") {
              this.print_hide_mobile = item.status == 1 ? true : false;
            } else if (item.name == "gas_oil") {
              this.gas_oil = item.status == 1 ? true : false;
              this.gas_oil_value = item.value;
            } else if (item.name == "diesel_oil") {
              this.diesel_oil = item.status == 1 ? true : false;
              this.diesel_oil_value = item.value;
            } else if (item.name == "must_register") {
              this.must_register = item.status == 1 ? true : false;
            } else if (item.name == "refund_order_take_coupon") {
              this.refund_order_take_coupon = item.status == 1 ? true : false;
            } else if (item.name == "invoice_button") {
              this.invoice_button = item.status == 1 ? true : false;
              this.invoice_create_time = item.invoice_create_time
                ? new Date(item.invoice_create_time)
                : "";
            } else if (item.name == "open_client_user_paypass") {
              this.open_client_user_paypass = item.status == 1 ? true : false;
            } else if (item.name == "hide_recharge_button") {
              this.hide_recharge_button = item.status == 1 ? true : false;
            } else if (item.name == "custom_money") {
              this.custom_money = item.status == 1 ? true : false;
              // this.custom_money_value = item.value
              console.log("chonghzi", item.value);
              if (item.value !== "") {
                let val = item.value.split(",");
                this.arrs = val.length > 0 ? val : ["100", "200", "300"];
                console.log(this.arrs);
              } else {
                this.arrs = ["100", "200", "300"];
              }
            } else if (item.name == "default_use_point") {
              this.default_use_point = item.status == 1 ? true : false;
            } else if (item.name == "hide_unit") {
              this.hide_unit = item.status == 1 ? true : false;
            } else if (item.name == "limit_custom") {
              this.limit_custom = item.status == 1 ? true : false;
              this.limit_custom_value = item.value;
            } else if (item.name == "recharge_notice") {
              this.recharge_notice = item.status == 1 ? true : false;
              this.recharge_notice_value = item.value;
            } else if (item.name == "print_remark") {
              this.print_remark = item.status == 1 ? true : false;
              this.print_remark_value = item.value;
            } else {
              var i = this.menuOptions.findIndex(x => x.id == item.name);
              if (i != -1) {
                this.menuOptions[i].value = item.status == 1 ? true : false;
              }
            }
          });
        }
      });
      getConfigButtonPos(data).then(res => {
        this.loading1 = false;
        if (res.code == 200) {
          console.log("基础设置", res.data);
          res.data.value.forEach((items, index) => {
            // if (this.basicsOptions[index].id == items.name) {
            //   this.basicsOptions[index].value =
            //     items.status == 1 ? true : false;
            // }
            var i = this.basicsOptions.findIndex(x => x.id == items.name);
            this.basicsOptions[i].value = items.status == 1 ? true : false;
          });
        }
      });
    },
    save() {
      var data = {
        token: this.token,
        app_id: this.app_id
      };
      var valueList = [];
      this.menuOptions.forEach(item => {
        var item = {
          name: item.id,
          status: item.value ? 1 : 0
        };
        valueList.push(item);
      });
      valueList.push({
        name: "receipt_button",
        status: this.receipt_button ? 1 : 0
      });
      valueList.push({
        name: "receipt_point",
        status: this.receipt_point ? 1 : 0
      });
      valueList.push({
        name: "default_use_point",
        status: this.default_use_point ? 1 : 0
      });
      valueList.push({
        name: "refund_order_take_coupon",
        status: this.refund_order_take_coupon ? 1 : 0
      });
      valueList.push({
        name: "invoice_button",
        status: this.invoice_button ? 1 : 0,
        invoice_create_time: this.invoice_create_time ? this.invoice_create_time : ""
      });
      valueList.push({
        name: "open_client_user_paypass",
        status: this.open_client_user_paypass ? 1 : 0
      });
      valueList.push({
        name: "hide_unit",
        status: this.hide_unit ? 1 : 0
      });
      valueList.push({
        name: "recharge_notice",
        status: this.recharge_notice ? 1 : 0,
        value: this.recharge_notice_value ? this.recharge_notice_value : ""
      });
      valueList.push({
        name: "print_remark",
        status: this.print_remark ? 1 : 0,
        value: this.print_remark_value ? this.print_remark_value : ""
      });
      valueList.push({ name: "cash_int", status: this.cash_int ? 1 : 0 });
      // valueList.push({ name: "show_cate", status: this.show_cate ? 1 : 0 });
      // 新增订单是否打印，充值订单是否打印
      valueList.push({
        name: "order_print_status",
        status: this.order_print_status ? 1 : 0
      });
      valueList.push({
        name: "hide_recharge_button",
        status: this.hide_recharge_button ? 1 : 0
      });
      // 用户是否强制注册
      if (this.app_id == 389 || this.app_id == 413) {
        valueList.push({
          name: "must_register",
          status: this.must_register ? 1 : 0
        });
      }
      valueList.push({
        name: "recharge_print_status",
        status: this.recharge_print_status ? 1 : 0
      });
      valueList.push({
        name: "normal_print_status",
        status: this.normal_print_status ? 1 : 0
      });
      valueList.push({
        name: "credit_print_status",
        status: this.credit_print_status ? 1 : 0
      });
      valueList.push({
        name: "print_hide_mobile",
        status: this.print_hide_mobile ? 1 : 0
      });
      valueList.push({
        name: "gas_oil",
        status: this.gas_oil ? 1 : 0,
        value: this.gas_oil ? this.gas_oil_value : ""
      });

      valueList.push({
        name: "custom_money",
        status: this.custom_money ? 1 : 0,
        value: this.custom_money ? this.arrs.join(",") : ""
      });
      valueList.push({
        name: "diesel_oil",
        status: this.diesel_oil ? 1 : 0,
        value: this.diesel_oil ? this.diesel_oil_value : ""
      });
      valueList.push({
        name: "limit_custom",
        status: this.limit_custom ? 1 : 0,
        value: this.limit_custom_value
      });

      data.value = JSON.stringify(valueList);
      console.log(data);
      setConfigButton(data).then(res => {
        if (res.code == 200) {
          this.$message.success("保存成功");
          this.init();
        } else {
          this.$message(res.msg);
        }
      });
      let basicsData = {
        token: this.token,
        app_id: this.app_id,
        value: []
      };
      this.basicsOptions.forEach(items => {
        var items = {
          name: items.id,
          status: items.value ? 1 : 0
        };
        basicsData.value.push(items);
      });
      basicsData.value = JSON.stringify(basicsData.value);
      setConfigButtonPos(basicsData).then(res => {
        if (res.code == 200) {
          // this.$message.success("保存成功");
          this.init();
        } else {
          this.$message(res.msg);
        }
      });
    },
    selectImg(i) {
      if (i % 2 == 1) {
        this.imgList[i].value = true;
        this.imgList[i - 1].value = false;
      } else {
        this.imgList[i].value = true;
        this.imgList[i + 1].value = false;
      }
    },
    gasChange(val) {
      if (Number(val)) {
        this.gas_oil_value = Number(val);
      } else {
        this.gas_oil_value = "";
      }
    },
    dieselChange(val) {
      if (Number(val)) {
        this.diesel_oil_value = Number(val);
      } else {
        this.diesel_oil_value = "";
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.bodycontent {
  border: 20px solid #f0f2f5;
  height: 100%;
  overflow: auto;
  padding: 0 18px;
  .page_title {
    height: 60px;
    line-height: 60px;
    font-size: 18px;
    border-bottom: 1px dashed #eee;
  }
  .page_form {
    padding-top: 30px;
    .input_box {
      width: 150px;
      margin-right: 10px;
    }
    .input_box_small {
      width: 50px;
    }
    .form_info_text {
      color: #aaa;
    }
  }
  .save_button {
    margin-top: 25px;
    padding-left: 100px;
    margin-bottom: 50px;
  }
}
.part_name {
  font-size: 16px;
  font-weight: bold;
}
.menu_item {
  display: inline-block;
  // min-width: 150px;
  margin-right: 55px;
  margin-bottom: 5px;
}
.ques_button {
  font-size: 21px;
  margin-left: 10px;
  vertical-align: middle;
  padding: 0;
}
.menu_item_name {
  margin-right: 5px;
  display: inline-block;
}
.input_box_mini {
  width: 70px;
}
.img_item {
  display: inline-block;
  position: relative;
  margin-right: 20px;
  width: 275px;
  height: 425px;
  border: 1px solid #eee;
  margin-bottom: 40px;
  img {
    width: 275px;
  }
  .img_text {
    position: absolute;
    bottom: -30px;
    width: 100%;
    height: 30px;
    line-height: 30px;
    text-align: center;
  }
}
.img_selected {
  border: 2px solid #409eff;
  color: #409eff;
}
.img_list {
  width: 1180px;
}
</style>
